import { action } from 'mobx';
import { detect } from 'detect-browser';
import { browserHistory } from 'react-router';
import jwtDecode from 'jwt-decode';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import NotificationService from '../../../core/services/NotificationService';
import { isRequired, isValidEmail } from '../../../core/validations';
import ContractService from '../../../core/services/ContractService';

class LoginService {
  fetch = new FetchService();
  form = new FormService();

  constructor() {
    this.form.validations = {
      email: [isRequired, isValidEmail],
      password: [isRequired],
      // environment: [isRequired],
    };
  }

  handleLogin = action(() => {
    localStorage.clear();

    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Inform your login and password', 'error');
      return;
    }

    const deviceInfo = detect();

    const selectedExtraColumns = localStorage.getItem('selectedExtraColumns');
    const environment = localStorage.getItem('environment');
    localStorage.clear();
    if (selectedExtraColumns) {
      localStorage.setItem('selectedExtraColumns', selectedExtraColumns);
    }
    if (environment) {
      localStorage.setItem('environment', environment);
    }

    // const url = {
    //   flexge: process.env.REACT_APP_API_URL,
    //   seedpr: process.env.REACT_APP_API_URL.replace('flexge.com', 'seedpr.flexge.com'),
    // }[this.form.getValue('environment')];
    // localStorage.setItem('environment', url);

    this.fetch
      .fetch({
        method: 'post',
        url: '/auth',
        headers: {
          Authorization: `Basic ${btoa(`${this.form.getValue('email')}:${this.form.getValue('password')}`)}`,
        },
        body: {
          browser: `${deviceInfo.name}_${deviceInfo.version}`,
          screenSize: `${window.screen.width}_x_${window.screen.height}`,
        },
      })
      .then(() => {
        if (this.fetch.data) {
          localStorage.setItem('email', this.fetch.data.email);
          localStorage.setItem('accessToken', this.fetch.data.accessToken);
          const decodedToken = jwtDecode(this.fetch.data.accessToken);
          localStorage.setItem('id', decodedToken.sub);
          localStorage.setItem('role', decodedToken.role);
          if (decodedToken.distributor && typeof decodedToken.distributor === 'string') {
            localStorage.setItem('distributor', decodedToken.distributor);
          }
          if (decodedToken.company && typeof decodedToken.company === 'string') {
            localStorage.setItem('company', decodedToken.company);
          }
          if (decodedToken.school) {
            localStorage.setItem('school', decodedToken.school);
          }
          if (decodedToken.contract) {
            localStorage.setItem('contract', decodedToken.contract);
          }

          ContractService.init();

          browserHistory.push('/');
          NotificationService.addNotification('Welcome again!', 'info');

          this.fetch
            .fetch({
              url: '/received-messages/count-unread',
            })
            .then(() => {
              if (this.fetch.data) {
                NotificationService.addNotification(
                  `You have ${this.fetch.data.total} new message${this.fetch.data.total === 1 ? '' : 's'}`,
                  'info'
                );
              } else {
                this.total = 0;
              }
            });
        }
        if (this.fetch.error) {
          if (
            this.fetch.response.data.error.indexOf('contract_blocked') > -1 ||
            this.fetch.response.data.error.indexOf('wrong_admin_platform') > -1
          ) {
            NotificationService.addNotification(this.fetch.error, 'error');
          } else {
            NotificationService.addNotification('Unable to login. Please check your credentials.', 'error');
          }
        }
      });
  });
}

export default LoginService;
